var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-amount-form"},[_c('Header'),_c('section',{staticClass:"main"},[_c('AmountSelector'),_c('ReceiptSend'),_c('PayMethods'),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }